<template>

    <div class="vsebina ">

        <div class="glava_vsebine adapt v-adapt">

            <div class="cols">
                <div class="col left grid-col-6">
                    <h1>Eko aplikacija</h1>
                    <p>Evidenca pridelovalcev in predelovalcev ekoloških in integriranih kmetijskih pridelkov oziroma
                        živil</p>
                </div>



                <div class="col right">
                </div>

            </div>
        </div>

        <div class="telo_vsebine adapt v-adapt">
            <p>
                Dobrodošli na spletnih straneh aplikacije za vodenje evidence pridelovalcev in predelovalcev ekoloških
                in integriranih kmetijskih pridelkov oziroma živil!
            </p>
            <p>
                Vsi prikazani izdelki, so skladni z uredbama EU št. 2018/848 in št. 2021/1165 ter z nacionalnimi
                zahtevami za ekološko pridelavo.
            </p>
            <p>
                V iskalnik vnesite ime izdelka, ime podjetja ali ime kategorije. Za ogled potrdila o ustreznosti
                kliknite na ikono <font-awesome-icon class="primary" icon="flask" />.
            </p>

            <form @submit.prevent="handleSubmit" class="k-form">
                <!-- <span>Številka certifikata, priimek pridelovalca ali naziv predelovalca</span> -->
                <div class="display-flex">
                    <input type="text" v-model="isci" placeholder="Ime izdelka, podjetja ali kategorije" name="isci"
                        id="isci" class="k-textbox k-textboxlong" v-on:keyup.enter="isciCertifikat" />
                    <span class="input-icon-search" @click="isciCertifikat"><font-awesome-icon icon="search" /></span>
                </div>


            </form>
            <div style="margin-bottom:4rem"></div>
            <div class="grid-wrapper">
                <Grid :data-items="inputi" :columns="columns">

                    <template v-slot:certifikat="{props}">
                        <td>
                            <a :href="'inputi/'+props.dataItem.id" target="_blank">
                        <font-awesome-icon icon="flask" />
                    </a>
                    </td>
                    </template>
                    <template v-slot:kategorija="{props}">
                        <td>
                         {{ props.dataItem.kategorije.filter(i=>i).join(", ") }}
                    
                    </td>
                    </template>
                    <template v-slot:podjetje="{props}">
                        <td>
                        <a v-if="props.dataItem.spletnastran" :href="props.dataItem.spletnastran" target="blank">
                        {{ props.dataItem.imepodjetja }}
                        </a>
                        <span v-if="!props.dataItem.spletnastran">{{ props.dataItem.imepodjetja }}</span>

                    </td>
                    </template>

                    <GridNoRecords>

                        Ni podatkov!

                    </GridNoRecords>
                </Grid>
                <div class="shema-loader" v-if="dataLoading"><font-awesome-icon icon="circle-notch" spin="spin" /></div>
            </div>


        </div>

    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { inputService } from '../services/input.service';
import { Grid, GridToolbar, GridNoRecords } from '@progress/kendo-vue-grid';
import Vue from 'vue';

export default {
    name: 'inputi',
    components: {
        'Grid': Grid,
        'GridNoRecords': GridNoRecords,
        'toolbar': GridToolbar,
    },
    computed: {
        ...mapState('alert', ['status'])

    },
    data() {
        return {
            isci: '',
            inputi: [],
            dataLoading: false,
            columns:[
                { field: "trgovskoime", title:"Izdelek",width:"200px",},
                { field: "imepodjetja", title:"Podjetje", cell:"podjetje",width:"150px",},
                { field: "kategorija", title:"Kategorija", cell:"kategorija"},
                { field: "id", title:"Potrdilo",width:"80px",cell:"certifikat"},
            ]
        }
    },
    created() {

        // this.success("test");
    },
    methods: {
        ...mapActions({ clearAlert: 'alert/clear' }),
        ...mapActions({ errorAlert: 'alert/error' }),

        handleSubmit(e) {

            e.preventDefault();
        },
        isciCertifikat(e) {
            this.clearAlert();
            let isci=this.isci;
            if (!isci) {
                this.errorAlert("Vnesti morate iskalni niz!")
                return;
            }
            if (isci.length < 3) {
                this.errorAlert("Iskalni niz mora biti dolg vsaj 3 znake")
                return;
            }
            let najdiniz=function(a,b){
                let niza=a.toLowerCase();
                let nizb=b.toLowerCase();
                if(niza.indexOf(nizb)>=0)
                    return true;
                else
                    return false;

            }
            // this.$router.push({ name: 'certifikatiJavno', params: { isci: this.isci } })
            //naloži kar tukaj...
            this.dataLoading=true;
            inputService.load().then(
                data => {
                    Vue.set(this, 'inputi', data.filter(d=>d.jeaktivna&&(najdiniz(d.imepodjetja,isci)||najdiniz(d.trgovskoime,isci)||najdiniz(d.kategorije.join(","),isci))));
                    //Vue.set(this, 'inputi', data);
                    this.dataLoading=false;
                },
                err=>{
                    this.errorAlert("Pri nalaganju podatkov je prišlo do napake")
                    this.dataLoading=false;
                }
            );
        }
    }
}


</script>

<style scoped>
h1 {
    color: white;
}

#isci {
    max-width: 500px
}

.primary {
    color: var(--accent);
}

.shema-loader {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 4rem;
    background-color: rgba(255, 255, 255, .5);
    color: var(--accent);
    text-align: center;
}

.grid-wrapper {
    position: relative;
}
.k-grid a{
    color: var(--accent) !important;
   
}
</style>